import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import NavBarButton from "./NavBarButton";

import { makeStyles } from "tss-react/mui";
import IconButton from "@mui/material/IconButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { logoutUser } from "../../../redux/actions/userActions";

// Icons
import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import HelpIcon from "@mui/icons-material/Help";

// Redux stuff
import { connect } from "react-redux";
import Tooltip from "@mui/material/Tooltip";

const useStyles = makeStyles()((theme) => ({
  menuIcon: {
    marginTop: 10,
  },
  allNavBarItems: {
    display: "inline-flex",
  },
  fullWidthButtons: {
    display: "inline-flex",
  },
  navBarButton: {
    marginRight: 28,
    textTransform: "none",
    fontSize: 18,
    fontWeight: 500,
    color: "rgb(0,0,0,0.87)",
  },
  menuOptionIcon: {
    marginRight: 10,
    fontSize: 22,
  },
}));

function NavBarButtonSetup(props) {
  const { classes } = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { authenticated, imageUrl } = props;

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    props.logoutUser();
  };

  // Buttons that show with full width page
  const fullWidthNavbarButtonsMarkup = (
    <div className={classes.allNavBarItems}>
      <div className={classes.fullWidthButtons}>
        <NavBarButton
          buttonText="Generate"
          linkTo="/generate"
          tip="Create fresh posts in seconds"
          btnClassName={classes.navBarButton}
        />
        <NavBarButton
          buttonText="Automate"
          linkTo="/automate"
          tip="Automate your monthly post creation"
          btnClassName={classes.navBarButton}
        />
        <NavBarButton
          buttonText="Schedule"
          linkTo="/scheduling"
          tip="Create your post release schedule"
          btnClassName={classes.navBarButton}
        />
        <NavBarButton
          buttonText="Templates"
          linkTo="/templates"
          tip="Create your own templates"
          btnClassName={classes.navBarButton}
        />
        <NavBarButton
          buttonText="Pricing"
          linkTo="/pricing"
          tip="Take your Social Media Marketing strategy to the next level"
          btnClassName={classes.navBarButton}
        />
        <Tooltip title="Help center">
          <IconButton
            onClick={() =>
              window.open("https://contentgenerator.tawk.help/", "_blank")
            }
            size="large"
          >
            <HelpIcon style={{ color: "darkgrey" }} />
          </IconButton>
        </Tooltip>
        <IconButton
          edge="end"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="primary"
          style={{
            padding: 7,
          }}
          size="large"
        >
          {authenticated ? (
            <Avatar alt="user avatar image" src={imageUrl} />
          ) : (
            <AccountCircle />
          )}
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={open}
          onClose={handleClose}
        >
          <div>
            <MenuItem onClick={handleClose} component={Link} to="/products">
              🛍️ Products
            </MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/blog">
              📝 Blog
            </MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/affiliate">
              💸 Affiliate Program
            </MenuItem>
            {authenticated && props.credentials.isFoundingPartner ? (
              <MenuItem
                onClick={handleClose}
                component={Link}
                to="/founding-partner-dashboard"
              >
                🌟 Founding Partner
              </MenuItem>
            ) : null}
            {authenticated ? (
              <Fragment>
                <MenuItem
                  onClick={handleClose}
                  component={Link}
                  to="/onboarding"
                >
                  🗺️ Onboarding
                </MenuItem>
                <MenuItem onClick={handleClose} component={Link} to="/profile">
                  👤 Profile
                </MenuItem>
                {(props.credentials.role &&
                  props.credentials.role == "admin") ||
                localStorage.getItem("pgrole") == "admin" ? (
                  <MenuItem onClick={handleClose} component={Link} to="/admin">
                    ⚙️ Admin page
                  </MenuItem>
                ) : null}
                <MenuItem onClick={handleLogout}>Log out</MenuItem>
              </Fragment>
            ) : (
              <Fragment>
                <MenuItem onClick={handleClose} component={Link} to="/login">
                  Login
                </MenuItem>
                <MenuItem onClick={handleClose} component={Link} to="/signup">
                  Sign Up
                </MenuItem>
              </Fragment>
            )}
          </div>
        </Menu>
      </div>
    </div>
  );

  // These buttons are always in the dropdown
  const standardButtons = (
    <Fragment>
      <MenuItem onClick={handleClose} component={Link} to="/generate">
        ➕ Generate
      </MenuItem>
      <MenuItem onClick={handleClose} component={Link} to="/automate">
        🤖 Automate
      </MenuItem>
      <MenuItem onClick={handleClose} component={Link} to="/scheduling">
        ⏰ Schedule
      </MenuItem>
      <MenuItem onClick={handleClose} component={Link} to="/templates">
        🖼️ Templates
      </MenuItem>
      <MenuItem onClick={handleClose} component={Link} to="/pricing">
        💲 Pricing
      </MenuItem>
      {/* <MenuItem onClick={handleClose} component={Link} to="/blog">
        📝 Blog
      </MenuItem> */}
      <MenuItem onClick={handleClose} component={Link} to="/affiliate">
        💸 Affiliate Program
      </MenuItem>
      {authenticated && props.credentials.isFoundingPartner ? (
        <MenuItem
          onClick={handleClose}
          component={Link}
          to="/founding-partner-dashboard"
        >
          🌟 Founding Partner
        </MenuItem>
      ) : null}
      {/* <MenuItem
        onClick={() => {
          window.open("https://contentgenerator.tawk.help/", "_blank");
          handleClose();
        }}
      >
        💁 Support
      </MenuItem> */}
    </Fragment>
  );

  // Drop down menu for small screens
  const menuNavbarButtonsMarkup = (
    <Fragment>
      <MenuOpenRoundedIcon
        color="primary"
        className={classes.menuIcon}
        edge="end"
        aria-label="Navbar menu"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
      />
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
      >
        {authenticated ? (
          <div>
            {standardButtons}
            <MenuItem onClick={handleClose} component={Link} to="/products">
              🛍️ Products
            </MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/onboarding">
              🗺️ Onboarding
            </MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/profile">
              👤 Profile
            </MenuItem>
            {(props.credentials.role && props.credentials.role == "admin") ||
            localStorage.getItem("pgrole") == "admin" ? (
              <MenuItem onClick={handleClose} component={Link} to="/admin">
                ⚙️ Admin page
              </MenuItem>
            ) : null}
            <MenuItem onClick={handleLogout}>Log out</MenuItem>
          </div>
        ) : (
          <div>
            {standardButtons}
            <MenuItem onClick={handleClose} component={Link} to="/products">
              🛍️ Products
            </MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/login">
              Login
            </MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/signup">
              Sign Up
            </MenuItem>
          </div>
        )}
      </Menu>
    </Fragment>
  );

  return (
    <div className={classes.navbarButtons}>
      {useMediaQuery("(min-width:800px)")
        ? fullWidthNavbarButtonsMarkup
        : menuNavbarButtonsMarkup}
    </div>
  );
}

NavBarButtonSetup.propTypes = {
  authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  authenticated: state.user.authenticated,
  credentials: state.user.credentials,
  imageUrl: state.user.credentials.imageUrl,
});

NavBarButtonSetup.propTypes = {
  logoutUser: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { logoutUser })(NavBarButtonSetup);
